export enum LanguageEnum {
  DE,
  IT
}
